import { useMemo, useState } from 'react';

import Modal from './Modal.jsx';

function todayInChina() {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(new Date());
}

export default function VaccinationForm({ item, record, optional = false, onClose, onSave, onDelete, busy }) {
  const initial = useMemo(() => ({
    administeredAt: record?.administeredAt ?? todayInChina(),
    vaccineName: record?.vaccineName || item?.name || '',
    doseLabel: record?.doseLabel || item?.dose || '',
    category: optional ? 'optional' : 'official',
    site: record?.site ?? '',
    manufacturer: record?.manufacturer ?? '',
    batchNumber: record?.batchNumber ?? '',
    note: record?.note ?? '',
  }), [item, optional, record]);
  const [form, setForm] = useState(initial);
  const [error, setError] = useState('');

  function update(field, value) {
    setForm((current) => ({ ...current, [field]: value }));
  }

  async function submit(event) {
    event.preventDefault();
    setError('');
    try {
      await onSave(form);
    } catch (cause) {
      setError(cause.message);
    }
  }

  return (
    <Modal
      title={optional ? '登记其他疫苗' : `${item.name} ${item.dose}`}
      description={optional ? '用于自费或地方增补疫苗，与国家免疫规划分开显示' : `计划日期 ${item.dueDate}`}
      onClose={onClose}
      footer={(
        <>
          {record && onDelete ? <button type="button" className="button button--danger-ghost" onClick={onDelete} disabled={busy}>删除登记</button> : <span />}
          <div className="modal-footer__actions">
            <button type="button" className="button button--secondary" onClick={onClose}>取消</button>
            <button type="submit" form="vaccination-form" className="button button--primary" disabled={busy}>{busy ? '保存中…' : '保存'}</button>
          </div>
        </>
      )}
    >
      <form id="vaccination-form" className="form-stack" onSubmit={submit}>
        {optional ? (
          <div className="form-row">
            <label className="field"><span>疫苗名称</span><input value={form.vaccineName} onChange={(e) => update('vaccineName', e.target.value)} required maxLength="100" /></label>
            <label className="field"><span>剂次</span><input value={form.doseLabel} onChange={(e) => update('doseLabel', e.target.value)} placeholder="例如：第 1 剂" maxLength="50" /></label>
          </div>
        ) : null}
        <label className="field"><span>实际接种日期</span><input type="date" value={form.administeredAt} onChange={(e) => update('administeredAt', e.target.value)} required /></label>
        <label className="field"><span>接种单位</span><input value={form.site} onChange={(e) => update('site', e.target.value)} placeholder="例如：社区卫生服务中心" maxLength="100" /></label>
        <div className="form-row">
          <label className="field"><span>厂家（可选）</span><input value={form.manufacturer} onChange={(e) => update('manufacturer', e.target.value)} maxLength="100" /></label>
          <label className="field"><span>批号（可选）</span><input value={form.batchNumber} onChange={(e) => update('batchNumber', e.target.value)} maxLength="100" /></label>
        </div>
        <label className="field"><span>备注（可选）</span><textarea rows="3" value={form.note} onChange={(e) => update('note', e.target.value)} maxLength="300" /></label>
        {error ? <p className="form-error" role="alert">{error}</p> : null}
      </form>
    </Modal>
  );
}
